import { setupContentUrl } from 'utils/contentUtils';

const normalizeText = (value) => {
  if (typeof value !== 'string') {
    return '';
  }
  return value.replace(/\s+/g, ' ').trim();
};

const parseHtml = (value) => {
  if (typeof value !== 'string' || value.trim() === '') {
    return null;
  }
  return new DOMParser().parseFromString(value, 'text/html');
};

const htmlToPlainText = (value) => {
  const parsed = parseHtml(value);
  if (!parsed) return '';

  return normalizeText(parsed.body.textContent || '');
};

const extractCategoryContent = (value) => {
  const parsed = parseHtml(value);
  if (!parsed) return { title: '', description: '' };

  const title = normalizeText(parsed.querySelector('strong')?.textContent || '');
  parsed.querySelectorAll('strong').forEach((node) => node.remove());

  return {
    title,
    description: normalizeText(parsed.body.textContent || ''),
  };
};

const extractMedia = (media) => {
  const mediaData = Array.isArray(media?.data) ? media.data[0] : media?.data;
  const attributes = mediaData?.attributes;
  if (!attributes) {
    return null;
  }
  return {
    url: setupContentUrl(attributes.url),
    alt: normalizeText(attributes.alternativeText) || normalizeText(attributes.name),
  };
};

const mapFreeRoamingCard = (program) => ({
  id: 'free-roaming',
  title: normalizeText(program.TITLE),
  buttonLabel: normalizeText(program.Button),
  buttonUrl: normalizeText(program.ButtonUrl),
  characteristics: (program.categories || []).map((category) => {
    const { title, description } = extractCategoryContent(category?.description);
    return {
      title,
      description,
      svg: extractMedia(category?.SVG) || { url: '', alt: '' },
    };
  }),
});

const mapMyInternetCard = (program) => ({
  id: 'my-internet',
  title: normalizeText(program.TITLE),
  buttonLabel: normalizeText(program.Button),
  buttonUrl: normalizeText(program.ButtonUrl),
  description: htmlToPlainText(program.Description),
});

export const mapStrapiEuProductsResponse = (response) => {
  const packageProgram = response?.data?.attributes?.PackageProgram?.[0];
  if (!packageProgram) return null;

  const programs = Array.isArray(packageProgram.Programs) ? packageProgram.Programs : [];

  const [freeRoamingProgram, myInternetProgram] = programs;

  return {
    title: normalizeText(packageProgram.Title),
    cards: [
      freeRoamingProgram && mapFreeRoamingCard(freeRoamingProgram),
      myInternetProgram && mapMyInternetCard(myInternetProgram),
    ].filter(Boolean),
  };
};
